function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var a11yManager = new (/*#__PURE__*/function () {
  function A11yManager() {
    var _this = this;
    _classCallCheck(this, A11yManager);
    if (window.MutationObserver && typeof window.MutationObserver === 'function') {
      var observer = new MutationObserver(function (_) {
        _this.ariaHiddenChecker();
      });
      this.ariaHiddenChecker();
      observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['aria-hidden']
      });
    }
  }
  return _createClass(A11yManager, [{
    key: "ariaHiddenChecker",
    value: function ariaHiddenChecker() {
      var focusables_elts = ['a[href]:not([inert])', 'area[href]:not([inert])', 'input:not([disabled]):not([inert])', 'select:not([disabled]):not([inert])', 'textarea:not([disabled]):not([inert])', 'button:not([disabled]):not([inert])', 'iframe:not([inert])', 'audio:not([inert])', 'video:not([inert])', '[contenteditable]:not([inert])', '[tabindex]:not([inert])'];
      document.querySelectorAll(focusables_elts.join(',')).forEach(function (el) {
        if (!el.tabIndexChecked) {
          var tabIndex = el.getAttribute('tabindex');
          if (tabIndex) {
            el.tabIndexOrig = tabIndex;
          }
          el.tabIndexChecked = true;
        }
      });
      var focusables_eltsHidden = focusables_elts.map(function (sel) {
        return '[aria-hidden="true"] ' + sel;
      });
      document.querySelectorAll(focusables_elts.join(',')).forEach(function (el) {
        if (el.tabIndexOrig) {
          el.setAttribute('tabindex', el.tabIndexOrig);
        } else {
          el.removeAttribute('tabindex');
        }
      });
      document.querySelectorAll(focusables_eltsHidden.join(',')).forEach(function (el) {
        el.setAttribute('tabindex', -1);
      });
    }
  }]);
}())();